module.exports = __webpack_public_path__ + "static/media/1.1a7e8c45.svg";